import { Marquee } from "../../ui/marquee";
import { cn } from "../../../lib/utils";

interface IMarquee {
  className?: string;
}

const AboutMarquee = ({ className }: IMarquee) => {
  const marqueeImages = [
    "/aboutus/marquee/about-marquee-1.png",
    "/aboutus/marquee/about-marquee-2.png",
    "/aboutus/marquee/about-marquee-3.png",
    "/aboutus/marquee/about-marquee-4.png",
    "/aboutus/marquee/about-marquee-5.png",
  ];

  return (
    <Marquee pauseOnHover className="[--duration:15s]">
      <div className="grid w-full gap-5 bg-transparent">
        <div className="flex gap-2 justify-between">
          {marqueeImages.map((image) => {
            return (
              <img
                key={image}
                src={image}
                alt=""
                className={cn("h-56 xl:h-[14rem]", className)}
              />
            );
          })}
        </div>
      </div>
    </Marquee>
  );
};

export default AboutMarquee;
